import DeleteRenderer from "../../components/AddCIPAndShutdown/deleteCellRender";
import EditRenderer from "../../components/AddCIPAndShutdown/editCellRender";
import ShareRenderer from "../../components/AddCIPAndShutdown/shareCellRender";
import { dateFormatter,timeFormatter } from "../../utils/tableDataFormatter";
import { CustomCellRenderer } from "./manageAcess";

export const PLANT_COL_DEF = (t) => [
  {
    headerName: t("ROOperationAdvisorTableStrings.name"),
    field: "name",
    sortable: true,
    flex: 1,
    wrapText: true,
    minWidth: 200,
    cellStyle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "block",
    },
    tooltipValueGetter: (params) => {
      return params.value;
    },
  },
  {
    headerName: t("ROOperationAdvisorTableStrings.city"),
    field: "city",
    sortable: true,
    flex: 1,
    minWidth: 175,
    cellStyle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "block",
    },
    tooltipValueGetter: (params) => {
      return params.value;
    },
  },
  {
    headerName: t("ROOperationAdvisorTableStrings.country"),
    field: "country",
    sortable: true,
    flex: 1,
    wrapText: true,
    minWidth: 200,
  },
  {
    headerName: t("ROOperationAdvisorTableStrings.createdon"),
    field: "created_at",
    valueFormatter: dateFormatter,
    sortable: true,
    flex: 1,
    minWidth: 225,
  },
  {
    headerName: t("ROOperationAdvisorTableStrings.createdBy"),
    field: "created_by",
    sortable: true,
    flex: 1,
    wrapText: true,
    minWidth: 225,
    cellStyle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "block",
    },
    tooltipValueGetter: (params) => {
      return params.value;
    },
  },
  {
    headerName: t("ROOperationAdvisorTableStrings.sharing"),
    field: "sharing",
    sortable: true,
    flex: 1,
    wrapText: true,
    minWidth: 150,
    cellRenderer: (params) => CustomCellRenderer({ ...params }),
  },
  {
    headerName: t("ROOperationAdvisorTableStrings.modifiedBy"),
    field: "modified_by",
    sortable: true,
    flex: 1,
    minWidth: 225,
    cellStyle: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "block",
    },
    tooltipValueGetter: (params) => {
      return params.value;
    },
  },
  {
    headerName: t("ROOperationAdvisorTableStrings.modifiedAt"),
    field: "modified_at",
    sortable: true,
    flex: 1,
    wrapText: true,
    minWidth: 225,
    valueFormatter: timeFormatter,
  },

  {
    colId: "delete",
    lockPinned: true,
    pinned: "right",
    width: 50,
    headerName: t("ValueStrings.delete"),
    cellRenderer: DeleteRenderer,
  },
  {
    colId: "share",
    lockPinned: true,
    pinned: "right",
    width: 50,
    headerName: t("ValueStrings.share"),
    cellRenderer: ShareRenderer,
  },
  {
    colId: "edit",
    lockPinned: true,
    pinned: "right",
    width: 50,
    headerName: t("ValueStrings.edit"),
    cellRenderer: EditRenderer,
  },
];
